import { MonthlyCalculationMode } from '../../api/scheduler-service';

/** UI-only display labels for the MonthlyCalculationMode enum.
 *  Backend exposes the enum via @Schema(enumAsRef=true); strings stay UI-side. */
export const MonthlyCalculationModeDisplayMap: Record<MonthlyCalculationMode, string> = {
  [MonthlyCalculationMode.OnSelectedDay]:                 'On Selected Day',
  [MonthlyCalculationMode.OnFirstDayOfMonth]:             'On First Day of the Month',
  [MonthlyCalculationMode.OnLastDayOfMonth]:              'On Last Day of the Month',
  [MonthlyCalculationMode.OnFirstBusinessDayOfMonth]:     'On First Business Day of the Month',
  [MonthlyCalculationMode.OnLastBusinessDayOfMonth]:      'On Last Business Day of the Month',
  [MonthlyCalculationMode.OnFirstSelectedWeekdayOfMonth]: 'On First Selected Weekday of the Month',
  [MonthlyCalculationMode.OnSecondSelectedWeekdayOfMonth]:'On Second Selected Weekday of the Month',
  [MonthlyCalculationMode.OnThirdSelectedWeekdayOfMonth]: 'On Third Selected Weekday of the Month',
  [MonthlyCalculationMode.OnFourthSelectedWeekdayOfMonth]:'On Fourth Selected Weekday of the Month',
  [MonthlyCalculationMode.OnLastSelectedWeekdayOfMonth]:  'On Last Selected Weekday of the Month',
};
